module.exports = __webpack_public_path__ + "static/media/exercises-step8.22c1f660.png";